<template>
  <div>
    <div class="container">
      <CreateTitle :title="page_title"/>

      <div class="create">
        <loader :isLoading="requestInProgress"/>

        <div class="row">
          <div class="col-sm">
            <CreatePageImage :src="image.url" :alt="image.alt" :width="image.width" />
          </div>

          <div class="col-sm">
            <div class="form-group">
              <label for="building-owner">Is Valid ID required to enter the building?</label>
              <div class="form-check-container">
                <div class="form-check form-check-inline">
                  <input
                    v-model="form.is_valid_id_required"
                    class="form-check-input"
                    type="radio"
                    name="for-requirement-id"
                    value="true">
                  <label class="form-check-label" for="yes-requirement-id">Yes</label>
                </div>

                <div class="form-check form-check-inline">
                  <input
                    v-model="form.is_valid_id_required"
                    class="form-check-input"
                    type="radio"
                    name="for-requirement-id"
                    value="false">
                  <label class="form-check-label" for="no-requirement-id">No</label>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="requirement-dress-code">With Dress Code?</label>
              <div class="form-check-container">
                <div class="form-check form-check-inline">
                  <input
                    v-model="form.have_dress_code"
                    class="form-check-input"
                    type="radio"
                    name="have_dress_code"
                    value="yes">
                  <label class="form-check-label" for="yes-have-dress-code">Yes</label>
                </div>

                <div class="form-check form-check-inline">
                  <input
                    v-model="form.have_dress_code"
                    class="form-check-input"
                    type="radio"
                    name="have_dress_code"
                    value="no">
                  <label class="form-check-label" for="no-have-dress-code">No</label>
                </div>
              </div>
              <input
                v-if="form.have_dress_code === 'yes'"
                v-model="form.dress_code"
                type="text"
                class="form-control"
                id="requirement-dress-code"
                placeholder="Casual Attire: No Shorts, No Sandos, No Slipper, No Open Toe Shoes"/>
              <small data-type="message"
                class="form-text text-muted error-message"
                v-if="form.have_dress_code === 'yes' && !form.dress_code"
                v-show="error.dress_code">
                {{ error.dress_code }}
              </small>
            </div>

            <div class="form-group">
              <label for="requirement-parking">With Parking Instructions?</label>
              <div class="form-check-container">
                <div class="form-check form-check-inline">
                  <input
                    v-model="form.have_parking_instructions"
                    class="form-check-input"
                    type="radio"
                    name="have_parking_instructions"
                    value="yes">
                  <label class="form-check-label" for="have_parking_instructions">Yes</label>
                </div>

                <div class="form-check form-check-inline">
                  <input
                    v-model="form.have_parking_instructions"
                    class="form-check-input"
                    type="radio"
                    name="have_parking_instructions"
                    value="no"
                    >
                  <label class="form-check-label" for="dont-have_parking_instructions">No</label>
                </div>
              </div>
              <input
                v-if="form.have_parking_instructions === 'yes'"
                v-model="form.parking_instructions"
                type="text"
                class="form-control"
                id="requirement-parking"
                placeholder="Parking is available at ... It costs P50/hr.">

                <small
                  id="parking-error"
                  data-type="message"
                  class="form-text text-muted error-message"
                  v-if="form.have_parking_instructions === 'yes' && !form.parking_instructions"
                  v-show="error.parking_instructions">
                  {{ error.parking_instructions }}
                </small>

            </div>

            <div class="form-group">
              <label for="requirements-others">Other Instructions (optional)</label>
              <input
                v-model="form.other_instructions"
                type="text"
                class="form-control"
                id="requirements-others"
                placeholder="Other instructions visitor should be aware of">
            </div>

            <div class="text-center">
              <small data-type="message" class="form-text text-muted error-message" v-if="error.message">
                {{ error.message }}
              </small>
              <button @click="validateBeforeSubmit()" type="submit" class="btn btn-primary">
                Next
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreateTitle from '@/components/common/CreateTitle'
import CreatePageImage from '@/components/common/CreatePageImage'
import Loader from '@/components/common/Loader'

import { ASSET_CREATE_ACCOUNT_2 } from '@/api/constants/ImageAssets'
import { APIService } from '../../api/APIService'

const api = new APIService()

export default {
  components: {
    CreateTitle,
    CreatePageImage,
    Loader
  },
  props: {
    companyId: String,
    isOrganizer: String
  },
  data() {
    return {
      page_title: 'Setup Access Instructions',
      image: ASSET_CREATE_ACCOUNT_2,
      form: {
        is_valid_id_required: 'false',
        have_dress_code: 'no',
        have_parking_instructions: 'no',
        dress_code: '',
        parking_instructions: '',
        other_instructions: ''
      },
      error: {
        dress_code: '',
        parking_instructions: '',
        message: '',
      },
      haveErrors: false,
      requestInProgress: false
    }
  },
  mounted() {
    if(this.isOrganizer !== 'false') this.redirectToPage()
  },
  methods: {
    validateBeforeSubmit() {
      this.error = {}
      this.haveErrors = false

      // validate if there is value
      if(this.form.have_dress_code === 'yes' && !this.form.dress_code) {
        this.error.dress_code = 'Please add Building Dress Code.'
        this.haveErrors = true
      }
      if(this.form.have_parking_instructions === 'yes' && !this.form.parking_instructions) {
        this.error.parking_instructions = 'Please add your parking instructions.'
        this.haveErrors = true
      }
      if(!this.haveErrors) this.updateProfileFields()
    },
    updateProfileFields() {
      const self = this
      const fields = { company_details: { ...this.form } }
      self.requestInProgress = true
      api.updateCompanyProfile(self.companyId, fields).then(data => {
        self.requestInProgress = false
        if(data){
          if(data.statusCode === 200) {
            self.requestInProgress = false
            self.redirectToPage()
          } else {
            self.requestInProgress = false
            self.error.message = data.message || 'Something went wrong'
          }
        } else {
          self.requestInProgress = false
          self.error.message = 'Session expired'
        }
      }).catch(err => {
        self.requestInProgress = false
        if(err.message) self.error.message = err.message
        else self.error.message = err
      })
    },
    redirectToPage() {
      this.$router.push(`/create-profile/business/${this.companyId}/agreements`)
    }
  }
}

</script>

<style>
  @import '../../assets/styles/form-style-1.css';
</style>

<style scoped>
  p {
    padding-top: 12px;
    font-family: "HKGrotesk-Light", Helvetica, sans-serif;
    font-size: 16px;
    color: #547181;
  }
</style>



// WEBPACK FOOTER //
// src/containers/business_profile/CreateBusinessProfileInstructions.vue